export type GazeLevel = 0 | 1 | 2 | 3;

export enum GRAM_ICON_TIME_STATS {
  LOW = 0,
  MID = 4,
  HIGH = 19
}
